import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  TbCalendarEvent,
  TbVaccine,
  TbHexagonLetterC,
  TbHexagonalPrismPlus
} from "react-icons/tb";

const leaveData = [
  {
    title: "Annual Leaves",
    count: "05",
    remaining: "07",
    icon: <TbCalendarEvent />,
    color: "black"
  },
  {
    title: "Medical Leaves",
    count: "11",
    remaining: "01",
    icon: <TbVaccine />,
    color: "blue"
  },
  {
    title: "Casual Leaves",
    count: "02",
    remaining: "10",
    icon: <TbHexagonLetterC />,
    color: "purple"
  },
  {
    title: "Other Leaves",
    count: "07",
    remaining: "05",
    icon: <TbHexagonalPrismPlus />,
    color: "pink"
  }
];

export default function LeaveOverviewCards() {
  return (
    <div>

      <Row className="g-3">

        {leaveData.map((item, index) => (

          <Col xl={3} md={6} sm={12} key={index}>

            <Card className={`leave-card leave-${item.color}`}>
              <Card.Body>

                <div className="card-top">

                  <div>
                    <p className="leave-title">{item.title}</p>
                    <h4 className="leave-count">{item.count}</h4>
                  </div>

                  <div className="icon-circle">
                    {item.icon}
                  </div>

                </div>

                <span className={`leave-badge badge-${item.color}`}>
                  Remaining Leaves : {item.remaining}
                </span>

              </Card.Body>
            </Card>

          </Col>

        ))}

      </Row>


<style>{`

.leave-card{
border-radius:10px;
border:1px solid #e6e6e6;
position:relative;
overflow:hidden;
padding:12px;
background:#fff;
}

/* curved background */

.leave-card::after{
content:"";
position:absolute;
top:-30px;
right:-30px;
width:110px;
height:110px;
border-radius:50%;
background:#f1f3f5;
}

/* top section */

.card-top{
display:flex;
align-items:center;
justify-content:space-between;
}

/* text */

.leave-title{
font-size:15px;
color:#6b7280;
margin-bottom:2px;
}

.leave-count{
font-size:18px;
font-weight:700;
color:#1f2937;
margin-bottom:6px;
}

/* icon */

.icon-circle{
width:60px;
height:60px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
font-size:28px;
color:#fff;
z-index:2;
}

/* badges */

.leave-badge{
display:inline-block;
font-size:12px;
padding:4px 10px;
border-radius:6px;
}

/* colors */

.leave-black .icon-circle{
background:#1f2937;
}

.badge-black{
background:#e9ecef;
color:#1f2937;
}

.leave-blue .icon-circle{
background:#2f80ed;
}

.badge-blue{
background:#dbeafe;
color:#2f80ed;
}

.leave-purple .icon-circle{
background:#9b51e0;
}

.badge-purple{
background:#f3e8ff;
color:#9b51e0;
}

.leave-pink .icon-circle{
background:#ff2f92;
}

.badge-pink{
background:#ffe4ef;
color:#ff2f92;
}

/* mobile */

@media (max-width:768px){

.icon-circle{
width:50px;
height:50px;
font-size:24px;
}

.leave-count{
font-size:20px;
}

}

`}</style>

    </div>
  );
}